import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import {
    selectAclList,
    selectVisibilityAclTable,
    selectAclLoading,
    selectVisibilityAclTableLoading,
    selectAclFirstLoad,
    fetchAclList,
    fetchVisibilityAclTable,
    fetchDeleteAcl,
} from "../model"
import { AddAclForm } from "./add-acl-form"
import { AclTable } from "./acl-table"
import { VisibilityAclTable } from "./visibility-acl-table"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"

export const AclPage = () => {
    const dispatch = useAppDispatch()
    const aclList = useAppSelector(selectAclList)
    const visibilityAclTable = useAppSelector(selectVisibilityAclTable)
    const isLoading = useAppSelector(selectAclLoading)
    const isVisibilityTableLoading = useAppSelector(selectVisibilityAclTableLoading)
    const isFirstLoad = useAppSelector(selectAclFirstLoad)
    const [isDeleting, setIsDeleting] = useState<string | null>(null)
    const [activeTab, setActiveTab] = useState<"create" | "table">("create")

    useEffect(() => {
        if (isFirstLoad) {
            dispatch(fetchAclList())
            dispatch(fetchVisibilityAclTable(undefined))
        }
    }, [dispatch, isFirstLoad])

    const handleDelete = async (aclId: string) => {
        setIsDeleting(aclId)
        try {
            await dispatch(fetchDeleteAcl(aclId)).unwrap()
            notify.success("ACL успешно удален")
        } catch (error) {
            notify.error(getErrorMessage(error))
        } finally {
            setIsDeleting(null)
        }
    }

    return (
        <div className="_page_container">
            <PageHeader title="Управление видимостью" />
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                    <div className="grid grid-cols-12 gap-[1px] w-full auto-rows-fr">
                        <div className="col-span-6">
                            <button
                                className={`font-mediumttf text-start uppercase hover:cursor-pointer text-lg xxl:text-[20px] screen:text-2xl py-6 px-5 rounded-l-2xl w-full transition bg-color-dark ${activeTab === "create" ? "text-color-acid" : "text-white hover:text-color-acid"}`}
                                onClick={() => setActiveTab("create")}
                            >
                                Создать ACL
                            </button>
                        </div>
                        <div className="col-span-6">
                            <button
                                className={`font-mediumttf text-start uppercase hover:cursor-pointer text-lg xxl:text-[20px] screen:text-2xl py-6 px-5 rounded-r-2xl w-full transition bg-color-dark ${activeTab === "table" ? "text-color-acid" : "text-white hover:text-color-acid"}`}
                                onClick={() => setActiveTab("table")}
                            >
                                Таблицы ACL
                            </button>
                        </div>
                    </div>
                </div>
                {activeTab === "create" && (
                    <>
                        <div className="col-span-12">
                            <AddAclForm />
                        </div>
                        <div className="col-span-12 ">
                            <AclTable
                                aclList={aclList}
                                isLoading={isLoading}
                                isDeleting={isDeleting}
                                onDelete={handleDelete}
                            />
                        </div>
                    </>
                )}
                {activeTab === "table" && (
                    <div className="col-span-12 ">
                        <VisibilityAclTable rows={visibilityAclTable} isLoading={isVisibilityTableLoading} />
                    </div>
                )}
            </div>
        </div>
    )
}
